import { User } from "@/models/User";
import client from "@/support/Client";

export class Lead extends User {
  protected $name: string = "Lead";
  protected $endpoint: string = "/leads";
  protected $fillable: string[] = [
    "answers",
    "first_name",
    "middle_name",
    "last_name",
    "street",
    "address_number",
    "address_addition",
    "address_additional_info",
    "zip_code",
    "city",
    "country",
    "phone",
    "quiz_completed",
    "delivery_at",
    "pickup_at",
    "email",
    "birthday_at",
    "invoice_address",
    "has_different_invoice_address",
    "has_paid_styling_fee",
    "company",
    "has_weekly_newsletter",
    "address_checked"
  ];

  public delivery_at?: any;
  public name?: string;
  public quiz_completed?: boolean;
  public pickup_at?: any;
  public birthday_at?: string;
  public answers?: any;
  public invoice_address?: InvoiceAddress;
  public images?: string[];
  public zip_code?: string;
  public address_number?: string;
  public address_addition?: string;
  public address_additional_info?: string;
  public city?: string;
  public street?: string;
  public country?: string;
  public credit_check?: any;
  public has_different_invoice_address?: boolean;
  public has_paid_styling_fee?: boolean;
  public token?: string;
  public id?: string;
  public status?: string;
  public last_answered_question?: string;
  public company?: string;
  public has_weekly_newsletter?: boolean;

  public createPaazlOrder(leadId: string, payload: any) {
    const endpoint = `${this.$endpoint}/${leadId}/create-paazl-order`;
    return client("post", endpoint, payload);
  }

  public upgradeToContact(id: string) {
    const url = `/leads/${id}/upgrade-to-contact`;
    return this.request("post", url, {});
  }
}

export interface InvoiceAddress {
  address_addition?: string;
  company?: string;
  address_additional_info?: string;
  address_number: string;
  city: string;
  street: string;
  zip_code: string;
  country: string;
}
